{
  "backButton": "Retour vers {prevMenuButton}",
  "moreActions": "Autres actions",
  "unavailable": "Indisponible, développer pour plus de détails"
}
